import isJointInvestment from "./isJointInvestment";
import isEntityInvestment from "./isEntityInvestment";
import isIndividualInvestment from "./isIndividualInvestment";

type ProfileEntity = {
  isDisregardedForTaxPurposes?: boolean;
};

type Investment = {
  profileType?: string;
  profileEntity?: ProfileEntity;
};

const WARNING_INDIVIDUAL =
  "Foreign status acknowledged. Mandatory U.S. withholding applies — the investor must provide Form W-8BEN. Treaty documentation, if any, is also the investor’s responsibility.";

const WARNING_REGARDED_ENTITY =
  "Foreign status acknowledged. Mandatory U.S. withholding applies — the investor must provide Form W-8BEN-E. Treaty documentation, if any, is also the investor’s responsibility.";

const WARNING_DISREGARDED_ENTITY =
  "Foreign status acknowledged. Mandatory U.S. withholding applies — the investor must provide Form W-8BEN / W-8BEN-E (owner). Treaty documentation, if any, is also the investor’s responsibility.";

const computeNonUsPersonWarning = (investment: Investment): string => {
  const isIndividual = isIndividualInvestment(investment);
  const isJoint = isJointInvestment(investment);

  const isPerson = isIndividual || isJoint;

  if (isPerson) {
    return WARNING_INDIVIDUAL;
  }

  const { profileEntity = {} } = investment;
  const { isDisregardedForTaxPurposes } = profileEntity;

  const isEntity = isEntityInvestment(investment);
  const isDisregarded = isDisregardedForTaxPurposes === true;

  const isDisregardedEntity = isEntity && isDisregarded;

  if (isDisregardedEntity) {
    return WARNING_DISREGARDED_ENTITY;
  }

  return WARNING_REGARDED_ENTITY;
};

export default computeNonUsPersonWarning;
